import Vue from 'vue'
import * as enums from '../enums/'

Object.defineProperty(Vue.prototype, '$enums', {
  value: enums,
  enumerable: true,
  configurable: true
})

export default {}
